<template>
    <div id="s-comboFix">

        <b-row class="justify-content-center">
                <!--BOUTON POUR OUVRIR LE COMBO-->
                <span class="btnContainer">
                    <b-button :disabled="disable" v-if="content.length > 0" class="btnShow btnShowStateStd" @click="$bvModal.show(name)">{{title}} : {{selectItem}}</b-button>
                </span>
        </b-row>
    
            <b-modal :body-bg-variant="getTheme.light" :header-bg-variant="getTheme.dark" :header-text-variant="getTheme.light" :id="name" :title="title" hide-footer>
                
                <!--CONTENU-->
                <div class="scroll borderMain">
                    <!--LIST DES ITEMS-->
                    <b-list-group style="margin-top: 5px">
                            <b-list-group-item 
                                :class="item.id == _Value ? 'cursorPoint btnStylSelected' : 'cursorPoint btnStyle'" 
                                v-for="(item) in content" :key="item.index" 
                                @click="handleInput(item.id)">
                               
                               <span v-if="item.text">{{item.text}}</span>
                               <span v-else>{{$t(item.lng)}}</span>
                            </b-list-group-item>
                    </b-list-group>

                </div>
            </b-modal>
    </div>
    
</template>

<script>
import {mapGetters} from 'vuex'

//content.text = Nom du text dans le fichier langue
//content.id = id a retourner

export default{
    name: 's-comboFix',
    props: ['content', 'disable', 'title', 'name', 'value'],
    data() {
        return {

        }
    },
    methods: {
        handleInput(valeur) {
            this._Value = valeur
            this.$bvModal.hide(this.name)
        }
    },
    computed: {
        ...mapGetters(['getTheme']),
        _Value: {
            get: function() {return this.value},
            set: function(modifiedValue){this.$emit('update:value', modifiedValue)}
        },
        selectItem()
        {
            if (this.$t(this.content[this._Value]?.text))
            {
                return this.content[this._Value]?.text
            }
            else
            {
                return this.$t(this.content[this._Value]?.lng)
            }

            
            //return this.$t(this.content[this._Value].text)
        }

    },
    watch: {

    }    
}
</script>

<style lang="scss" scoped>
.borderMain{
    background: white;
    padding-left: 5px;
    border-left: 1px solid lightgray;
    border-top: 1px solid lightgray;
    border-bottom: 1px solid lightgray;
}
.btnContainer{
    width: 100%;
    margin-left: 15px;
    margin-right: 15px;
}
.btnShow{
    cursor: pointer;
    width: 100%;
    //margin-left: 15px;
    //margin-right: 15px;
    border-radius: $sBorderRadius;
    color: black;
    text-align: center;
    background-color: white;
}
.btnShowStd{
    border: 1px solid black;
}
.btnShowStateOff{
    border: 1px solid $cStateOff;
}
.btnShowStateOn{
    border: 1px solid $cStateOn;
}
.btnOff{
    cursor: pointer;
    width: 100%;
    margin-left: 15px;
    margin-right: 15px;
    border-radius: $sBorderRadius;
    border: 1px solid black;
    color: white;
    text-align: center;
    background-color: darkgray;
}
.btnFiltre{
    min-width: 68px;
    height: 45px;
}
.btnFiltreBackGroundSelect{
    background-color: $btnQteSelect;
    color: $cText;
}

.btnStyle{
    border-radius: 5px;
    width: 98%;
    height: 40px;
    line-height: 40px;
    position: static;
    margin-bottom: 2px;
    text-align: left;
    border: 1px solid $btnBorder;
    background-image: linear-gradient(90deg, $cContainerLeftBorder 5px, $cContainerBackColor 5px);
    text-transform:lowercase;
    ::first-letter{
        text-transform: uppercase;
    }
}

.btnStyle:hover{
    background-image: linear-gradient(90deg, $cContainerLeftBorder 5px, $btnBackHover 5px);
}
.btnStyle:active{
    background-image: linear-gradient(90deg, $btnBackActive 5px, $cContainerLeftBorder 5px);
}
.btnStylSelected{
    border-radius: 5px;
    width: 98%;
    height: 40px;
    line-height: 40px;
    position: static;
    margin-bottom: 2px;
    text-align: left;
    border: 1px solid $btnBorder;
    background-image: linear-gradient(90deg, $btnBackActive 5px, $cContainerLeftBorder 5px);
    ::first-letter{
        text-transform: uppercase;
    }
    font-weight: bold;
}

.btnRemove{
    border-radius: 5px;
    width: 98%;
    height: 40px;
    line-height: 40px;
    position: static;
    margin-bottom: 2px;
    margin-top: 5px;
    text-align: left;
    border: 1px solid $btnBorder;
    background-image: linear-gradient(90deg, $cboRemoveLeft 5px, $cboRemoveBack 5px);
}
.btnRemove:hover{
    background-image: linear-gradient(90deg, $cboRemoveLeft 5px, $btnBackHover 5px);
}
.btnRemove:active{
    background-image: linear-gradient(90deg, $cboRemoveLeftS 5px, $cboRemoveBackS 5px);
}

span {
  display: inline-block;
  vertical-align: top;
  line-height: normal;
}

.addLicContainer{
    width: 100%;
    margin: 0px 0px 0px 0px;
}
.btnLeft
{
    margin-bottom: $sBotSpace;
    margin-left: 5%;
    width: 30%;
    height: 40px;
}
.txtLeft{
    width: 65%;
}

</style>



        <!--selectStatus: Boolean, //Permet de mettre le contour du bouton en Vert / Rouge selon si la selection est obligatoire ou non
        name: String,
        title: String,
        content: null,
        showField: String,
        returnField: String,
        selectedItems: null,
        disable: Boolean,
        noNone: Boolean, //Si on eneleve le AUCUN
        baseZero: Boolean //Si la base est une base 0 ou une base 1 ou autre.... a TRUE c'est une base 1-->